// 서비스별 SEO 콘텐츠 — /services/{serviceId} 페이지에서 사용.
// 대표 확정 공식 가격표(2026-05-12) + USP "모든 세차에 스팀이 기본" 반영.
// 자동차 메인 6개. 실내 집중케어·오토바이는 serviceContentExtra.js로 분리.
import { SERVICE_CONTENT_EXTRA } from './serviceContentExtra';

const MAIN_CONTENT = {
  // 자동차 — 외부 세차 (단독)
  'exterior-only': {
    title: '수원 외부 세차 — KOA DETAILING (경차 2만원~)',
    description: '수원 곡반정 KOA DETAILING 외부 세차. 고온 스팀이 기본 — 거품·물세차만 하는 곳과 다릅니다. 경차 2만 / 승용·SUV 3만 / 탑차·특수 4만. 도장면 흠집 없는 비접촉 세정.',
    h1: '외부 세차',
    subtitle: '고온 스팀이 기본인 비접촉 외부 세정',
    keywords: ['수원 외부 세차', '수원 스팀세차', '곡반정 외부세차', '권선구 손세차', '비접촉 세차'],
    intro: 'KOA DETAILING는 옵션이 아니라 기본으로 고온 스팀을 사용합니다. 일반 손세차장이 거품과 물세차만 하는 동안, 저희는 스팀이 먼저 오염을 분리한 뒤 부드럽게 닦아냅니다. 도장면 흠집(스월마크) 누적 위험이 거의 없습니다.',
    benefits: [
      '고온 스팀 비접촉 세정 — 회전 브러시·강한 압력 없음',
      '친환경 약품 + 스팀 헹굼으로 약품 잔류 최소화',
      '경차 2만원 / 승용·SUV 3만원 / 탑차·특수차 4만원',
    ],
    bestFor: '평소 출퇴근 차량 정기 관리, 황사·장마철 빠른 정리.',
    duration: '30~45분',
    process: [
      '차량 외부 사전 점검',
      '고온 스팀으로 먼지·황사 1차 분리',
      '친환경 약품 거품 도포 + 손세척',
      '스팀 헹굼 + 미세섬유 타월 마감',
    ],
    faqs: [
      {
        q: '자동 세차기와 다른 점이 뭔가요?',
        a: '자동 세차기 회전 브러시는 도장면에 미세 흠집(스월마크)을 남깁니다. KOA DETAILING는 스팀이 먼저 오염을 분리한 뒤 손으로 닦아 도장면 흠집을 만들지 않습니다.',
      },
      {
        q: '얼마나 자주 받으면 좋나요?',
        a: '출퇴근 차량 기준 2주에 1회, 황사·장마철엔 주 1회 권장. 잔기스 누적을 막아 도장 수명이 길어집니다.',
      },
      {
        q: '오토바이도 가능한가요?',
        a: '오토바이는 "오토바이 외부세차" 메뉴(5만원)를 이용해주세요. 자동차와 작업 방식이 달라 별도 메뉴로 분리돼 있습니다.',
      },
    ],
    relatedServices: ['premium-wash', 'premium-polish', 'glass-coating-ceramic'],
  },

  // 자동차 — 내부 세차 (단독)
  'interior-only': {
    title: '수원 내부 세차 — KOA DETAILING (경차 3만원~)',
    description: '수원 곡반정 KOA DETAILING 내부 세차. 시트·매트·콘솔·도어트림 표면 청소 + 고온 스팀 살균. 경차 3만 / 승용·SUV 4만 / 탑차·특수 6만. 권선구·곡반정 손님 환영.',
    h1: '내부 세차',
    subtitle: '시트·매트·콘솔까지 — 고온 스팀 살균이 기본 포함',
    keywords: ['수원 내부 세차', '시트 클리닝', '차량 내부 청소', '권선구 실내 디테일링', '실내 스팀 살균'],
    intro: '외부는 깨끗한데 실내가 지저분한 차량을 위한 메뉴입니다. 매트·시트 표면·콘솔·도어트림을 약품으로 청소한 뒤 고온 스팀으로 살균까지 마무리합니다.',
    benefits: [
      '매트 분리 후 흡진·세척 — 모래·먼지 100% 제거',
      '시트·콘솔 약품 청소 + 스팀 살균',
      '경차 3만원 / 승용·SUV 4만원 / 탑차·특수차 6만원',
    ],
    bestFor: '아이·반려동물 동승 차량, 흡연 차량, 음료 흘림 자국, 중고차 판매 직전.',
    duration: '1~1.5시간',
    process: [
      '실내 사전 점검 + 짐 정리',
      '매트 분리 후 진공·세척',
      '바닥 진공 + 시트 표면 진공',
      '대시보드·콘솔·도어트림 약품 청소',
      '시트 표면 약품 케어 + 스팀 살균',
      '유리 내측 청소',
    ],
    faqs: [
      {
        q: '시트 깊은 곳 박힌 음료 자국도 제거되나요?',
        a: '표면 자국은 이 메뉴로 가능합니다. 시트 내부까지 침투한 자국·악취는 "실내 집중케어"를 권장드립니다.',
      },
      {
        q: '반려동물 털도 제거되나요?',
        a: '네, 진공과 전용 솔로 처리합니다. 접착력 강한 털은 시간이 더 걸릴 수 있습니다.',
      },
    ],
    relatedServices: ['premium-wash', 'premium-polish', 'exterior-only'],
  },

  // 자동차 — 내+외 세차 (통합 풀패키지)
  'premium-wash': {
    title: '수원 내+외 세차 — KOA DETAILING (경차 4만원~)',
    description: '수원 곡반정 KOA DETAILING 내+외 통합 세차. 외부 + 내부 한 번에. 경차 4만 / 승용·SUV 6만 / 탑차·특수 10만. 모든 메뉴에 고온 스팀이 기본.',
    h1: '내+외 세차',
    subtitle: '외부 + 내부 한 번에 — 외부·내부 따로 받는 것보다 저렴',
    keywords: ['수원 손세차', '수원 풀세차', '외부 내부 세차', '곡반정 손세차', '내외세차'],
    intro: '외부 도장면 정성 세척부터 실내 매트·콘솔·시트 표면 청소까지 한 번에 끝내는 통합 세차입니다. 외부·내부를 따로 받는 것보다 시간·가격 모두 효율적이고, 한 달에 한 번 깊은 관리에 적합합니다.',
    benefits: [
      '외부 + 내부 한 번에 — 따로 받는 것보다 시간·가격 절약',
      '모든 공정에 고온 스팀 기본 포함 (옵션 추가 결제 없음)',
      '경차 4만원 / 승용·SUV 6만원 / 탑차·특수차 10만원',
    ],
    bestFor: '한 달에 한 번 깊은 관리, 가족 차량, 중고차 판매 직전 컨디션 정리.',
    duration: '1.5~2시간',
    process: [
      '외부 사전 점검 + 휠/타이어 약품 도포',
      '고온 스팀 외부 세척 + 거품 손세척',
      '실내 매트 분리 후 흡진·세척',
      '대시보드·콘솔·도어트림 약품 청소',
      '시트 표면 진공 + 스팀 살균',
      '외부 마감 닦기 + 유리 손질',
    ],
    faqs: [
      {
        q: '실내 시트 깊은 곳까지 청소되나요?',
        a: '시트 표면 진공·약품 케어가 포함됩니다. 시트 내부 깊은 부분(스팀 침투·약품 추출)은 "실내 집중케어"를 권장드립니다.',
      },
      {
        q: '소요 시간 동안 어디서 기다리나요?',
        a: '매장 내 손님 대기 공간을 마련해두었습니다. 인근 카페로 가셨다 오시는 분들도 많습니다.',
      },
      {
        q: '광택·코팅도 같이 받을 수 있나요?',
        a: '네, 같은 방문에 광택·유리막 코팅까지 묶어서 받으시면 작업 효율이 좋습니다. 총 소요는 4~6시간 정도 길어집니다.',
      },
    ],
    relatedServices: ['exterior-only', 'premium-wash', 'premium-polish'],
  },

  // 자동차 — 광택 (폴리싱)
  'premium-polish': {
    title: '수원 광택 — KOA DETAILING 프리미엄 폴리싱 (경차 10만원~)',
    description: '수원 곡반정 KOA DETAILING 프리미엄 광택. 도장면 흠집·산화·물자국 제거 후 신차 같은 광 살리기. 경차 10만 / 승용 12만 / SUV 14만 / 탑차 10만. 코팅 전 필수.',
    h1: '광택 (폴리싱)',
    subtitle: '도장면 흠집·산화·물자국 제거 후 신차 같은 광 살리기',
    keywords: ['수원 광택', '수원 폴리싱', '차 흠집 제거', '도장 복원', '권선구 디테일링'],
    intro: '도장면에 누적된 잔기스·소용돌이 자국·산화·물자국을 폴리싱 머신과 컴파운드로 단계별로 제거합니다. 신차에 가까운 광을 다시 살리는 작업이며, 유리막 코팅을 받으시기 전 권장 전처리입니다.',
    benefits: [
      '자동 세차기로 누적된 소용돌이 자국 80% 이상 제거',
      '도장면 산화·물자국·황변 복원',
      '경차 10만 / 승용 12만 / SUV 14만 / 탑차·특수차 10만',
    ],
    bestFor: '신차 시절 광을 되찾고 싶은 차량, 코팅 받으시기 전, 중고차 판매 직전 가치 상승.',
    duration: '4~6시간',
    process: [
      '외부 세차 (철분·타르 제거)',
      '도장면 두께·상태 측정',
      '컴파운드 단계별 폴리싱',
      '미세 흠집 제거용 폴리시 마감',
      '실란트 도포 (보호 단계)',
      '최종 디테일 점검',
    ],
    faqs: [
      {
        q: '광택과 코팅의 차이가 뭔가요?',
        a: '광택은 도장면 흠집을 깎아내 평탄화하는 작업이고, 코팅은 그 위에 보호막을 입히는 작업입니다. 깊은 광을 원하시면 광택만으로도 좋고, 1~2년 유지하고 싶으시면 코팅까지 받으시면 됩니다.',
      },
      {
        q: '깊은 흠집도 제거되나요?',
        a: '도장 두께 측정 후 안전 범위 내에서 제거 가능한 흠집은 90% 이상 처리됩니다. 도장 아래까지 들어간 깊은 흠집은 부분 도색 영역이라 별도 안내드립니다.',
      },
      {
        q: '오토바이 광택도 가능한가요?',
        a: '오토바이는 차종별 상의로 진행됩니다. 도장면 굴곡이 많아 작업 시간·가격이 자동차 기준과 다를 수 있어 매장 문의(010-3931-4528)로 견적드립니다.',
      },
    ],
    relatedServices: ['glass-coating-ceramic', 'hydro-coating', 'premium-wash'],
  },

  // 자동차 — 유막·발수 코팅 (신규)
  'hydro-coating': {
    title: '수원 유막·발수 코팅 — KOA DETAILING (자동차 10만원)',
    description: '수원 곡반정 KOA DETAILING 유막·발수 코팅. 유리·도장 유막 제거 후 발수 코팅. 자동차 일괄 10만 / 탑차·특수 5만. 비 오는 날 시야·세차 빈도 개선.',
    h1: '유막·발수 코팅',
    subtitle: '유리·도장 유막 제거 + 발수 코팅 — 비 오는 날 시야 확보',
    keywords: ['수원 유막 제거', '발수 코팅', '곡반정 유리 코팅', '권선구 유막제거', '비 오는 날 시야'],
    intro: '유리에 누적된 유막을 분해 제거한 뒤 발수 코팅 약품을 도포합니다. 비 오는 날 운전 시 시야가 확연히 개선되고, 빗방울이 구슬처럼 흘러내려 세차 빈도가 줄어듭니다. 도장면에도 같은 발수 효과를 줍니다.',
    benefits: [
      '유막 제거 후 코팅 — 비 오는 날 와이퍼 한 번에 깨끗',
      '빗방울이 구슬처럼 흘러내려 빗물 자국 누적 방지',
      '자동차 일괄 10만원 / 탑차·특수차 5만원',
    ],
    bestFor: '비 오는 날 운전 잦은 분, 유리에 물때·기름때 누적된 차량, 외부 주차 차량.',
    duration: '1.5~2시간',
    process: [
      '외부 세차로 표면 오염 1차 제거',
      '유리 유막 분해제 도포 + 시간 두기',
      '유막 제거 후 헹굼',
      '발수 코팅 약품 도포 (유리 + 도장)',
      '정착 시간 대기 후 닦기',
    ],
    faqs: [
      {
        q: '얼마나 오래 유지되나요?',
        a: '운행 빈도와 세차 약품에 따라 다릅니다. 평균 3~6개월 정도 발수 효과가 유지되며, 효과가 떨어지면 재시공이 가능합니다.',
      },
      {
        q: '유리막 코팅(세라믹)과 뭐가 다른가요?',
        a: '유리막 코팅은 도장면 보호가 주 목적이고 1~2년 유지됩니다. 유막·발수 코팅은 유리·도장 발수가 주 목적이고 더 짧게 유지되지만 가격이 1/2 수준입니다.',
      },
      {
        q: '비 오는 날도 시공이 가능한가요?',
        a: '실내 작업 공간에서 진행되므로 날씨와 무관합니다. 단 시공 후 24시간은 비 노출을 피해주시는 것을 권장합니다.',
      },
    ],
    relatedServices: ['glass-coating-ceramic', 'premium-polish', 'exterior-only'],
  },

  // 자동차 — 유리막 코팅 (세라믹)
  'glass-coating-ceramic': {
    title: '수원 유리막 코팅 (세라믹) — KOA DETAILING (경차 20만원~)',
    description: '수원 곡반정 KOA DETAILING 세라믹 유리막 코팅. 발수·도장 보호 1~2년 유지. 경차 20만 / 승용·SUV·탑차 25만. 광택 후 시공 권장. 권선구·곡반정 디테일링 전문.',
    h1: '유리막 코팅 (세라믹)',
    subtitle: '세라믹 베이스 — 발수·도장 보호 1~2년 유지',
    keywords: ['수원 유리막 코팅', '세라믹 코팅', '도장 보호', '곡반정 코팅', '수원 자동차 코팅'],
    intro: '세라믹 베이스 약품으로 도장면에 미세 보호막을 형성합니다. 빗물·새똥·먼지가 도장에 직접 닿지 않게 막아주고, 세차할 때 오염이 쉽게 떨어져 나갑니다. 효과는 차량 사용 빈도에 따라 1~2년 유지됩니다.',
    benefits: [
      '발수 효과로 세차 빈도 절반으로 감소',
      '새똥·송진·도로 분진이 도장에 직접 박히는 것 방지',
      '경차 20만 / 승용·SUV·탑차 25만 (광택 후 시공 권장)',
    ],
    bestFor: '신차 출고 직후, 광택 직후, 빨간색·검정색 등 변색 두드러지는 색상 차량.',
    duration: '6~8시간 + 양생 24시간',
    process: [
      '외부 세차 + 광택 (도장면 평탄화)',
      '코팅 약품 도포용 사전 클리닝',
      '세라믹 코팅 약품 단계별 도포',
      '구역별 정착 시간 대기',
      '여분 약품 닦아내기 + 광 마감',
      '24시간 양생 안내',
    ],
    faqs: [
      {
        q: '효과가 정말 1~2년 가나요?',
        a: '관리 빈도에 따라 다릅니다. 자동 세차기·강한 약품·외부 주차 시 1년 정도, 손세차만 받으시고 실내 주차 시 2년 가까이 유지됩니다.',
      },
      {
        q: '광택을 안 받고 코팅만 받아도 되나요?',
        a: '신차라면 광택 없이 코팅만으로도 충분합니다. 1년 이상 운행 차량은 도장면 흠집이 누적돼 있어 광택을 먼저 받으시는 것이 코팅 효과를 살리는 길입니다.',
      },
      {
        q: '시공 후 바로 운행해도 되나요?',
        a: '시공 직후 외부 주행은 가능하지만, 24시간은 비·물 노출을 피해주세요. 약품이 완전히 정착(양생)되는 시간이 필요합니다.',
      },
    ],
    relatedServices: ['premium-polish', 'hydro-coating', 'premium-wash'],
  },

};

export const SERVICE_CONTENT = { ...MAIN_CONTENT, ...SERVICE_CONTENT_EXTRA };
export const SERVICE_CONTENT_IDS = Object.keys(SERVICE_CONTENT);
